if (!customElements.get('slider-component')) {
    class SliderComponent extends HTMLElement {
        constructor() {
            super();
            this.initialized = false;
            this.boundScrollHandler = null;
            this.boundPrevHandler = null;
            this.boundNextHandler = null;
        }

        connectedCallback() {
            this.init();
        }

        init() {
            if (this.initialized) return;
            
            this.slider = this.querySelector('.new-slider-container');
            this.prevButton = this.querySelector('.new-slider-button-prev');
            this.nextButton = this.querySelector('.new-slider-button-next');
            
            // Critical check: slider must exist
            if (!this.slider) return;
            
            this.initialized = true;
            
            // Bound handlers for cleanup
            this.boundScrollHandler = () => this.updateButtons();
            this.boundPrevHandler = () => this.scroll('prev');
            this.boundNextHandler = () => this.scroll('next');
            
            // Update buttons on scroll
            this.slider.addEventListener('scroll', this.boundScrollHandler, { passive: true });
            
            // Previous button
            if (this.prevButton) {
                this.prevButton.addEventListener('click', this.boundPrevHandler);
            }
            
            // Next button
            if (this.nextButton) {
                this.nextButton.addEventListener('click', this.boundNextHandler);
            }
            
            // Check slide count (safe, no layout reads)
            this.checkSlideCount();
        }

        scroll(direction) {
            if (!this.slider) return;
            
            const firstSlide = this.slider.querySelector('.new-slider-item');
            if (!firstSlide) return;
            
            const slideWidth = firstSlide.offsetWidth;
            const gap = parseInt(getComputedStyle(this.slider).gap) || 10;
            const scrollAmount = direction === 'next' ? slideWidth + gap : -(slideWidth + gap);
            
            this.slider.scrollBy({ 
                left: scrollAmount, 
                behavior: 'smooth' 
            });
        }

        updateButtons() {
            if (!this.slider || !this.prevButton || !this.nextButton) return;
            
            try {
                const { scrollLeft, scrollWidth, clientWidth } = this.slider;
                const isAtStart = scrollLeft <= 1;
                const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
                
                this.prevButton.style.display = isAtStart ? 'none' : 'flex';
                this.nextButton.style.display = isAtEnd ? 'none' : 'flex';
            } catch (e) {
                // Silently fail if DOM not ready
            }
        }

        checkSlideCount() {
            if (!this.slider) return;
            
            const slides = this.slider.querySelectorAll('.new-slider-item');
            
            if (slides.length <= 1) {
                if (this.prevButton) this.prevButton.style.display = 'none';
                if (this.nextButton) this.nextButton.style.display = 'none';
            }
        }

        disconnectedCallback() {
            // Clean up event listeners
            if (this.slider && this.boundScrollHandler) {
                this.slider.removeEventListener('scroll', this.boundScrollHandler);
            }
            if (this.prevButton && this.boundPrevHandler) {
                this.prevButton.removeEventListener('click', this.boundPrevHandler);
            }
            if (this.nextButton && this.boundNextHandler) {
                this.nextButton.removeEventListener('click', this.boundNextHandler);
            }
        }
    }

    customElements.define('slider-component', SliderComponent);
}
